import {
  Menu as MenuTail,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
  Card,
  Typography,
  ListItemSuffix,
  IconButton,
} from '@material-tailwind/react';
import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Listar from './Listar';
import AddButton from '../Buttons/AddButton';
import { AddModalCatLn } from '../Modal/AddModalCatLn';

const Menu = ({ item, news }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [modal, setModal] = useState(false);

  const handleModel = () => {
    setModal(!modal);
  };
  const handleMenu = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <div className="w-full px-2">
      <div className="flex justify-between items-center rounded-md shadow-md border border-black  dark:bg-darkButtonColor bg-gray-400 dark:text-white sm:px-2 relative ">
        <Button variant="text" className="w-full text-left dark:text-darkText" onClick={handleMenu}>
          {item.nome}
        </Button>
        <div className="flex items-center">
          <AddButton handleModel={handleModel} />
          <IconButton variant="text" onClick={handleMenu}>
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`h-3.5 w-3.5 transition-transform cursor-pointer dark:text-white ${
                openMenu ? 'rotate-180' : ''
              }`}
            />
          </IconButton>
        </div>
      </div>
      {openMenu && (
        <ul className="mt-2 z-10 w-full">
          <Listar array={item.categorias} />
        </ul>
      )}
      <AddModalCatLn
        title="Adicionar categoria"
        modal={modal}
        handleModal={handleModel}
        url="categoria"
        id={item.id}
        news={news}
      />
      {/* {result?.sucess && <MsgSucess reset={resetInfo} />} */}
    </div>
  );
};

export default Menu;
